<KryptonCardFormSpawnPoint :section="method"></KryptonCardFormSpawnPoint>